import { Shop } from "@mui/icons-material";
import { CommApiInstance } from "Utils/CommApiInstance";

const ShopBnrLstApi = async (
    gameSvcCd:string|null,
) => {
    return await CommApiInstance.post(`${gameSvcCd}/bnr_lst/SHOP`,{
        apiBody:{
        }
    })
    .then((Resp) => Resp.data);
}
export default ShopBnrLstApi;
